export const decodeUnicodeString = (unicodeString: string): string => {
	return unicodeString.replace(/U\+([0-9A-F]{4,6})/gi, (_, code) => {
		return String.fromCodePoint(parseInt(code, 16));
	});
};